import { render, staticRenderFns } from "./RefinementList.vue?vue&type=template&id=0649c7e1&"
import script from "./RefinementList.vue?vue&type=script&lang=js&"
export * from "./RefinementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RefinementList.vue"
export default component.exports